$(document).ready(function() {
    $('.fancybox').fancybox();
});

// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "heroSlickSlider") {
    $this.find('.decor-slider-wrapper').heroSlickSlider();
  }else if($this.data('section') == "heroOwlSlider") {
    $this.heroOwlSlider();
  }else if($this.data('section') == "ProudctCarouselSlider") {
    $this.find('.product-carousel').SlickCarouselSlider();
  }else if($this.data('section') == "CollectionProductContent") {
    $this.find('.product-slider-wrapper').SlickCarouselSlider();
  }else if($this.data('section') == "IsotopCollectionProduct") {
    $this.IsotopCollection();
  }else if($this.data('section') == "BannerSection") {
    $this.BannerSection();
  }else if($this.data('section') == "CountDownBanner") {
    $this.CountDownBanner();
  }else if($this.data('section') == "CollectionSLider") {
    $this.find('.banner_collection_slider').SlickCarouselSlider();
  }else if($this.data('section') == "featurCategory") {
    $this.find('.feature_category_slider').SlickCarouselSlider();
  }else if($this.data('section') == "lookbooBanner") {
    $this.LookBanner();
  }else if($this.data('section') == "BlogPostSliderJs") {
    $this.find('.blog-post-slider').SlickCarouselSlider();
  }else if($this.data('section') == "TestmonialSlider") {
    $this.find('.testmonialSliderOne').SlickCarouselSlider();
  }else if($this.data('section') == "TestmonialSlider2") {
    $this.find('.testmonialSliderTwo').SlickCarouselSlider();
  }else if($this.data('section') == "TestmonialSlider3") {
    $this.find('.testmonialSliderThree').SlickCarouselSlider();
  }else if($this.data('section') == "BrandLogos") {
    $this.find('.BrandSlider').SlickCarouselSlider();
  }else if($this.data('section') == "BrandLogos2") {
    $this.find('.BrandSlider2').SlickCarouselSlider();
  }else if($this.data('section') == "CategoryCaousel") {
    $this.find('.category_slick_carousel').SlickCarouselSlider();
  }else if($this.data('section') == "RelatedProudct") {
    $this.find('.related_product_slide').SlickCarouselSlider();
  }else if($this.data('section') == "customProductSlider") {
    $this.find('.customProductCarousel').SlickCarouselSlider();
  }else if($this.data('section') == "HeaderSection") {
    $this.headerSectionJs();
  }else if($this.data('section') == "collectionTemplate") {
    $this.collectionTemplaetFn();
  }else if($this.data('section') == "InstagramSlider") {
    $this.InstagramSection();
  }else{}   
}

// Header Section
$.fn.headerSectionJs = function(){
  // Mega menu
  megaMneu();
  
  // Header Actcion 
  headerjsFn();
  
  // Lazload Js
  lazyLoadjs();
  
  
  // Menu Product Carousel
  var $carousel = $('[data-owl-carousel]');
  var $OwlMenuProduct = $('.menu_product_contain');
  // Owl Carousel Options
  if ($carousel.length) {
    $carousel.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  /* single product activation */
  if($OwlMenuProduct.length > 0){
    $OwlMenuProduct.owlCarousel();  
  };
  
};

// Collection Template
$.fn.collectionTemplaetFn = function(){
 // Lazload Image
  lazyLoadjs();
  
  /*----------  shop advance filter area toggle  ----------*/
  $('#advance-filter-active-btn').on('click', function(){
    $(this).toggleClass('active');
    $('#shop-advance-filter-area').slideToggle();
  });

};

// Hero Slider
$.fn.heroSlickSlider = function() {
  var $lezadaSlickSlider = this;
  $lezadaSlickSlider.slick({
    autoplay: true,
    arrows: true,
    centerMode: true,
    centerPadding: '360px',
    slidesToShow: 1,
    prevArrow: '<button class="slick-prev"><i class="ti-angle-left"></i></button>',
    nextArrow: '<button class="slick-next"><i class="ti-angle-right"></i></button>'
  });

  // Lazload Js
  lazyLoadjs();
};



// Hero Fulid Slider
$.fn.heroOwlSlider = function(){
  
   // Variable
    var $carousel = $('[data-owl-carousel]');
    var $menuSlider = $('.slider_wrapper');
    var $heroSlider = $('.hero-slider-wrapper');
    var $HalfSliderBanner = $('.half_slider_active');
    // Owl Carousel Options
    if ($carousel.length) {
      $carousel.each(function() {
        $(this).owlCarousel($(this).data('owl-carousel'));
      });
    }
    
    //Hero Fluid Slider Activation
	$heroSlider.owlCarousel();
  
    // Menu With Slider
    $menuSlider.owlCarousel();
  
  	// Half Slider With Banner
    $HalfSliderBanner.owlCarousel();
  
     // Mega Menu
     megaMneu();

    // Category Menu
    catMenuCollapse();

    // Lazload Js
    lazyLoadjs();
};


// Slick Slider
$.fn.SlickCarouselSlider = function(){
  // Lazload Image
  lazyLoadjs();

  // Product Carousel Slider
  var $this = this;
  if($this.length > 0){
    $this.slick({
      prevArrow: '<button class="slick-prev"><i class="ti-angle-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="ti-angle-right"></i></button>'
    });
  };

};


// Isotope Product
$.fn.IsotopCollection = function(){
	// Lazload Image
  lazyLoadjs();

  // Isotope Collection Product
  var activeId = $(".product-filter-menu li");
  var IsotopActive = $(".product-isotope");
  if(IsotopActive.length > 0){
    activeId.on('click', function () {
      var $this = $(this),
          filterValue = $this.data('filter');

      IsotopActive.isotope({
        filter: filterValue,
        
        layoutMode: 'fitRows'

      });
      activeId.removeClass('active');
      $this.addClass('active');
    });
  };
};


// CountDown Banner
$.fn.CountDownBanner = function(){
    lazyLoadjs();
    // CountDwon Js
    CountDownJs();
}

// Banner
$.fn.BannerSection = function(){
  // Lazload Image
  lazyLoadjs();

  // Tilter Js
  if ($('.tilter').length > 0) {
    $('.tilter').tilt({
      maxTilt: 40,
      perspective: 800,
      easing: "cubic-bezier(.03,.98,.52,.99)",
      scale: 1,
      speed: 800,
      transition: true,
    });
  } 

};

// LookBoo Banner
$.fn.LookBanner = function(){
  // Lazload Image
  lazyLoadjs();

  // LookBook Js
  lookbookkjs()
  
}

// Instgaram Section
$.fn.InstagramSection = function(){
	var activation = this.find('[data-username]'),
      activeId = activation.attr('id'),
      clientUsername = activation.attr('data-username'),
      instagramHastag = activation.attr('data-hashtag'),
      ItemsLimit = activation.attr('data-limit'),
      imageSize = activation.attr('data-size'),
      instaslider = ".instagram-carousel";
  
  $.instagramFeed({
    'tag': instagramHastag,
    'username': clientUsername,
    'container': "#"+activeId,
    'display_profile': false,
    'display_biography': false,
    'display_gallery': true,
    'styling': false,
    'items': ItemsLimit,
    'margin': 1,
    'image_size': imageSize
  });
  
  var $instagramNews = "#"+activeId+instaslider,
      $slidesToShow = activation.data('slidetoshow'),
      $slidesAutoplay = activation.data('slideautoplay'),
      $slideshowtablet = activation.data('slideshowtablet'),
      $slideshowlgmobile = activation.data('slideshowlgmobile'),
      $slideshowsmmobile = activation.data('slideshowsmmobile');
  
  $($instagramNews).on("DOMNodeInserted", function (e) {
    if(e.target.className == 'instagram_gallery') {
      $("." + e.target.className).slick({
        slidesToShow: $slidesToShow,
        slidesToScroll: 1,
        autoplay: $slidesAutoplay,
        dots: false,
        
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><i class="ti-angle-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="ti-angle-right"></i></button>',
        responsive: [
         {
           breakpoint: 1199,
           settings: {
             slidesToShow: $slidesToShow,
           }
         },
         {
           breakpoint: 991,
           settings: {
             slidesToShow: $slideshowtablet,
           }
         },
         {
           breakpoint: 767,
           settings: {
             slidesToShow: $slideshowlgmobile,
           }
         },
         {
           breakpoint: 575,
           settings: {
             slidesToShow: $slideshowsmmobile,
           }
         }

       ]
      })
    }
  });  
};


// LookBook JS
function lookbookkjs(){
  var clothTag = $('.cloth-tag');
  clothTag.each(function(){
    var $this = $(this),
        topValue = $this.data('top'),
        leftValue = $this.data('left');
    $this.css({"top": topValue, "left": leftValue});

  });
 
  $('.cloth-tag__icon').on('click', function(e) {
    $(this).siblings('.cloth-tag__content').addClass('active');
    e.stopPropagation();
  });

  $('.lookbook_close__icon').on('click', function(e){
    $(this).parent('.cloth-tag__content').removeClass('active');
    e.stopPropagation();
  });

  $('body').on('click', function(e) {
    if (!$(e.target).is('.cloth-tag__content.active'))
      $('.cloth-tag__content.active').removeClass('active');
  });

  
};
lookbookkjs();


// mega menu
function megaMneu(){
  $('.mega_dropdown').parent('ul').addClass('mega-menu');
  $('.mega-menu').parent('li').addClass('mega_item');
  $('.drop_item').parent('ul').addClass('single-column-menu');
  $('.multi_item').parent('ul').addClass('single-column-menu ');
  $('.mega-menu').each(function(){
    if($(this).children('li').length){
      var ulChildren = $(this).children('li').length;
      if (ulChildren == 5) {
        $(this).addClass( "mega-menu-column-5" );
      }else if (ulChildren == 4) {
        $(this).addClass( "mega-menu-column-4" );
      }else if(ulChildren == 3){
        $(this).addClass( "mega-menu-column-3 mega-menu-column-4" );
      }else if(ulChildren == 2){
        $(this).addClass( "mega-menu-column-2  mega-menu-column-4" );
      }else if(ulChildren == 1){
        $(this).addClass( "mega-menu-column-4 mega-menu-column-1" );
      }else {
        $(this).addClass( "mega-menu-column-5 mega-full" );
      }
    }
  });
};

// Header js
function headerjsFn(){

  /* active and deactive cart overlay */
  $('#offcanvas-cart-icon, #offcanvas-cart-icon-2').on('click', function(){
    $('#cart-overlay').addClass('active-cart-overlay');
    $('.cart-overlay-close').addClass('active').removeClass('inactive');
    $('body').addClass('active-body-search-overlay');
  });

  $('#cart-close-icon, .cart-overlay-close').on('click', function(){
    $('#cart-overlay').removeClass('active-cart-overlay');
    $('.cart-overlay-close').addClass('inactive').removeClass('active');
    $('body').removeClass('active-body-search-overlay');
  });

  /* activate and deactivate search overlay*/

  $('#search-icon, #search-icon-2').on('click', function(){
    $('#search-overlay').addClass('active-search-overlay');
    $('body').addClass('active-body-search-overlay');
  });

  $('#search-close-icon').on('click', function(){
    $('#search-overlay').removeClass('active-search-overlay');
    $('body').removeClass('active-body-search-overlay');
  });



  /* active and deactive about overlay */
  $('#offcanvas-about-icon').on('click', function(){
    $('#about-overlay').addClass('active-about-overlay');
    $('.overlay-close').addClass('active').removeClass('inactive');
    $('body').addClass('active-body-search-overlay');
  });

  $('#about-close-icon, .overlay-close').on('click', function(){
    $('#about-overlay').toggleClass('active-about-overlay');
    $('.overlay-close').addClass('inactive').removeClass('active');
    $('body').removeClass('active-body-search-overlay');
  });
  
  
  
  /*-- vertical menu icon  -----*/
	
	$('#vertical-menu-icon').on('click', function(){
		$(this).toggleClass('active');
		$('#vertical-menu-dark').toggleClass('active');
	});
  
  
  //overlay menu   

  /*Variables*/
  var $verticalCollapsibleMenu = $('#vertical-collapsible-menu'),
      $verticalCollapsibleSubMenu = $verticalCollapsibleMenu.find('.sub-menu');

  /*Close Off Canvas Sub Menu*/
  $verticalCollapsibleSubMenu.slideUp();

  /*Category Sub Menu Toggle*/
  $verticalCollapsibleMenu.on('click', 'li a', function(e) {
    var $this = $(this);
    if ( $this.siblings('.sub-menu').length) {
      e.preventDefault();
      if ($this.siblings('ul:visible').length){
        $this.siblings('ul').slideUp();
      }else {
        $this.closest('li').siblings('li').find('ul:visible').slideUp();
        $this.siblings('ul').slideDown();
      }
    };
  });   
    
    $('#overlay-menu-icon').on('click', function(){
      $('#overlay-navigation-menu').removeClass('overlay-navigation-inactive').addClass('overlay-navigation-active');
    });

    $('#overlay-menu-close-icon').on('click', function(){
      $('#overlay-navigation-menu').removeClass('overlay-navigation-active').addClass('overlay-navigation-inactive');
    });

  
  // Check Terms & Condition
  $('#ageree_term_cond').on('click', function(){
    $(this).parent('.cart-buttons').toggleClass('disabled');
  });


  /*----  Vertical Menu  ------*/
  $('.header-vertical').parent('body').addClass('vertical-header');

  
  // Mobile Menu Activation
  mobilemenuJS();
  
  //Sticky Menu JS
  stickyMenu();  
  
};

// Sticky Menu
function stickyMenu(){
  var windows = $(window);
  var screenSize = windows.width();
  var sticky = $('.header-sticky');
  var sliderBottomHeader = $('.slider-bottom-header-sticky');


  windows.on('scroll', function () {
    var scroll = windows.scrollTop();

    var headerHeight = sticky.height();
    var sliderBottomHeaderHeight = sliderBottomHeader.height();
    var sliderHeight = $('.header-bottom-slider-area').height();

    var headerPosition = sliderBottomHeaderHeight + sliderHeight;

    if (screenSize >= 300) {
      if (scroll < headerHeight) {
        sticky.removeClass('is-sticky');
      } else {
        sticky.addClass('is-sticky');
      }
    }


    if (screenSize >= 300) {
      if (scroll < headerPosition) {
        sliderBottomHeader.removeClass('is-sticky');
      }else {
        sliderBottomHeader.addClass('is-sticky');
      }
    }


  });

}

// Mobile Menu JS
function mobilemenuJS(){

  // DL MENU
  var $dlmenu = $('#dl-menu');
  if($dlmenu.length > 0){
    $dlmenu.dlmenu({
      animationClasses : { classin : 'dl-animate-in-2', classout : 'dl-animate-out-2' },
      useActiveItemAsLink: true,
    });
  };


  //offcanvas mobile menu
  $("#mobile-menu-trigger").on('click', function(){
    $("#mobile-menu-overlay,.menu_offcanvas_overlay").addClass("active");
  });

  $("#mobile-menu-close-trigger,.menu_offcanvas_overlay").on('click', function(){
    $("#mobile-menu-overlay,.menu_offcanvas_overlay").removeClass("active");
  });

  var $offCanvasNav = $('.offcanvas-navigation'),
      $offCanvasNavSubMenu = $offCanvasNav.find('.sub-menu');

  /*Add Toggle Button With Off Canvas Sub Menu*/
  $offCanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i></i></span>');

  /*Close Off Canvas Sub Menu*/
  $offCanvasNavSubMenu.slideUp();

  /*Category Sub Menu Toggle*/
  $offCanvasNav.on('click', 'li a, li .menu-expand', function(e) {
    var $this = $(this);
    if ( ($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand')) ) {
      e.preventDefault();
      if ($this.siblings('ul:visible').length){
        $this.parent('li').removeClass('active');
        $this.siblings('ul').slideUp();
      } else {
        $this.parent('li').addClass('active');
        $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
        $this.closest('li').siblings('li').find('ul:visible').slideUp();
        $this.siblings('ul').slideDown();
      }
    }
  });
  
  $("#mobile_bar_info_trigger").on('click', function(){
    $("#mobile_topbar_menu_overlay,.topbar_offcanvas_overlay").addClass("active");
  });

  $("#mobile_topbar_close_trigger,.topbar_offcanvas_overlay").on('click', function(){
    $("#mobile_topbar_menu_overlay,.topbar_offcanvas_overlay").removeClass("active");
  });


};

// CountDown js
function CountDownJs(){
	$('[data-countdown2]').each(function () {
    var $this = $(this),
        finalDate = $(this).data('countdown2');
    $this.countdown(finalDate, function (event) {
      $this.html(event.strftime('<div class="single-countdown"><span class="single-countdown__time">%D</span><span class="single-countdown__text">Days</span></div><div class="single-countdown"><span class="single-countdown__time">%H</span><span class="single-countdown__text">Hours</span></div><div class="single-countdown"><span class="single-countdown__time">%M</span><span class="single-countdown__text">Minutes</span></div><div class="single-countdown"><span class="single-countdown__time">%S</span><span class="single-countdown__text">Seconds</span></div>'));
    });
  });
  
  // Style 2
  $('[data-countdown3]').each(function () {
    var $this = $(this),
        finalDate = $(this).data('countdown3');
    $this.countdown(finalDate, function (event) {
      $this.html(event.strftime('<div class="single-countdown"><span class="single-countdown__time">%D</span><span class="single-countdown__text">Days</span></div><div class="single-countdown"><span class="single-countdown__time">%H</span><span class="single-countdown__text">Hours</span></div><div class="single-countdown"><span class="single-countdown__time">%M</span><span class="single-countdown__text">Minutes</span></div><div class="single-countdown"><span class="single-countdown__time">%S</span><span class="single-countdown__text">Seconds</span></div>'));
    });
  });
  
  // Style 3
  
  $('[data-countdown4]').each(function() {
    var $this = $(this), finalDate = $(this).data('countdown4');
    $this.countdown(finalDate, function(event) {
      $this.html(event.strftime('<div class="single-countdown"><span class="single-countdown__time">%D</span><span class="single-countdown__text">Days</span></div><div class="single-countdown"><span class="single-countdown__time">%H</span><span class="single-countdown__text">Hrs</span></div><div class="single-countdown"><span class="single-countdown__time">%M</span><span class="single-countdown__text">mins</span></div><div class="single-countdown"><span class="single-countdown__time">%S</span><span class="single-countdown__text">Secs</span></div>'));
    });
  });  
  
    $('[data-countdown]').each(function() {
    var $this = $(this), finalDate = $(this).data('countdown');
    $this.countdown(finalDate, function(event) {
      $this.html(event.strftime('<div class="countdown-area"><div class="single-countdown"><div class="count-number">%D</div><div class="count-title">days</div></div><div class="single-countdown"><div class="count-number">%H</div><div class="count-title">Hr</div></div><div class="single-countdown"><div class="count-number">%M</div><div class="count-title">Min</div></div><div class="single-countdown"><div class="count-number">%S</div><div class="count-title">Sec</div></div></div>'));
    });
  });

}
CountDownJs();
// Category Menu Collapse
function catMenuCollapse(){
  $("#categories_title_trigger").on("click", function() {
    $(this).toggleClass('active');
    $('#categories_menu_collapse').slideToggle('medium');
  }); 

};

// Lazloady Js
function lazyLoadjs(){
  $("img.lazyload").lazyload();
};
  


(function ($) {
   	jQuery(document).ready(function(){
      "use strict";

      /*------ Menu sticky and scrol top -------*/
      var windows = $(window);
      var screenSize = windows.width();

      windows.on('scroll', function () {
        var scroll = windows.scrollTop();
		
		//code for scroll top

		if (scroll >= 400) {
			$('.scroll-top').fadeIn();
		} else {
			$('.scroll-top').fadeOut();
		}
       
	});


	/*----------  Scroll to top  ----------*/
	$('.scroll-top').on('click', function () {
		$('html,body').animate({
			scrollTop: 0
		}, 2000);
	});

	
	/*--Masonry Activation  ---*/

		var $masonry = $('.masonry-category-layout');
		var $grid = $('.grid-item');
		$grid.hide();

      if($masonry.length > 0){
		$masonry.imagesLoaded( function() {
			$grid.fadeIn();
			$masonry.masonry({
				itemSelector: '.grid-item',
				columnWidth: '.grid-item--width2',
				percentPosition: true,
				//gutter: 10
			});
		});
      };

      // Creative Home Masonry
      var $gridCreativeHome = $('.grid-item');
      var $masonryCreativeHome = $('.masonry-category-layout--creativehome');
      $gridCreativeHome.hide();    
      
      if($masonryCreativeHome.length > 0){
        $masonryCreativeHome.imagesLoaded( function() {
          $gridCreativeHome.fadeIn();  
          $masonryCreativeHome.masonry({
            itemSelector: '.grid-item',
            columnWidth: 1,
            percentPosition: true,
            //gutter: 30
          });
        });
      };
	
	 /*----------  blog post masonry  ----------*/

      var $masonryBlogPost = $('.blog-post-wrapper--masonry');
      var $gridBlogPost = $('.grid-item');
      $gridBlogPost.hide();
      if($masonryBlogPost.length > 0){
        $masonryBlogPost.imagesLoaded( function() {
          $gridBlogPost.fadeIn();
          $masonryBlogPost.masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-item',
            percentPosition: true,
            //gutter: 30
          });
        });
      };

	/*----  WOW JS activation  ------*/
	
	new WOW().init();
      

    /*----------  Parallax active  ----------*/
      var parallax = $('.jarallax');
      if(parallax.length > 0){
        parallax.jarallax({
          speed: 0.2
        });
      };
      
      
      /*----------   Mailchimp  ----------*/
      $('#mc-form-2').ajaxChimp({
        language: 'en',
        callback: mailChimpResponse2,
        // ADD YOUR MAILCHIMP URL BELOW HERE!
        url: 'https:\/\/devitems.us11.list-manage.com\/subscribe\/post?u=6bbb9b6f5827bd842d9640c82&amp;id=05d85f18ef'

      });

      function mailChimpResponse2(resp) {
        if (resp.result === 'success') {
          $('.mailchimp-success-2').html('' + resp.msg).fadeIn(900);
          $('.mailchimp-error-2').fadeOut(400);

        } else if (resp.result === 'error') {
          $('.mailchimp-error-2').html('' + resp.msg).fadeIn(900);
        }
      }

      
      $('#mc-form').ajaxChimp({
        language: 'en',
        callback: mailChimpResponse,
        // ADD YOUR MAILCHIMP URL BELOW HERE!
        url: 'https:\/\/devitems.us11.list-manage.com\/subscribe\/post?u=6bbb9b6f5827bd842d9640c82&amp;id=05d85f18ef'

      });

      function mailChimpResponse(resp) {
        if (resp.result === 'success') {
          $('.mailchimp-success').html('' + resp.msg).fadeIn(900);
          $('.mailchimp-error').fadeOut(400);
          //$('.mc-newsletter-form').addClass('mailSuccess');

        } else if (resp.result === 'error') {
          $('.mailchimp-error').html('' + resp.msg).fadeIn(900);
        }
      }

      
	/*--- instagram image slider ----*/
				
	jQuery(window).on('load', function () {var newselttershow = 768;
      
		if (screenSize >= newselttershow) {
         
			$('.newsletter-overlay-area').addClass('newsletter-overlay-active');
          

			setTimeout(function(){ 
				$('#newsletter-content').addClass('show-popup');
			 }, 1000);
		}/*----------  tippy js  ----------*/
      tippy('[data-tippy-content]');
		
	});
      
     /*----------  Newsletter Activation ----------*/var newslettershowmobile = 768;

      if (screenSize >= newslettershowmobile) {

        $("#newsletter-popup-close-icon").on("click", function(){
          $('.newsletter-overlay-area').removeClass('newsletter-overlay-active').addClass('newsletter-overlay-inactive');
          $('#newsletter-content').removeClass('show-popup').addClass('hide-popup');
        });
      }/*------  magnific popup -----*/
      var $magnicficpopup = $('.popup-video');

      if($magnicficpopup.length > 0) {
        $magnicficpopup.magnificPopup({
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false
        });
      };
	
	
	/*---- smooth scroll on shoppable Home ------*/
	
	$('#smooth-scroll-section').on('click', function (event) {
		event.preventDefault();
	
		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top - sticky.height() -50
		}, 500);
	});

	/*-----  Quantity Counter  ----*/

	$('.pro-qty').append('<a href="#" class="inc qty-btn">+</a>');
	$('.pro-qty').prepend('<a href="#" class= "dec qty-btn">-</a>');
	$('.qty-btn').on('click', function (e) {
		e.preventDefault();
		var $button = $(this);
		var oldValue = $button.parent().find('input').val();
		if ($button.hasClass('inc')) {
			var newVal = parseFloat(oldValue) + 1;
		} else {
			// Don't allow decrementing below zero
			if (oldValue > 0) {
				var newVal = parseFloat(oldValue) - 1;
			} else {
				newVal = 0;
			}
		}
		$button.parent().find('input').val(newVal);
	});

      
	/*----------  perfect scroll bar active  ----------*/

	$('.ps-scroll').each(function() {
		if($('.ps-scroll').length) {
			const ps = new PerfectScrollbar($(this)[0]);
		}
	});

	
     
      /*------   Nice Select ------*/
      var $niceSelect = $('.nice-select');  
      if($niceSelect.length > 0){
        $niceSelect.niceSelect();
      }

	/*----------  sidebar category dropdown  ----------*/
	
	var sidebarCategoryParent = $('.single-filter-widget--list--category li.has-children, .single-sidebar-widget--list--category li.has-children');
	sidebarCategoryParent.append('<a href="#" class="expand-icon">+</a>');

	var expandIcon = $('.expand-icon');
	expandIcon.on('click', function(e){
		e.preventDefault();
		$(this).prev('ul').slideToggle();
		var htmlAfter = '-';
		var htmlBefore = '+';


		if ($(this).html() == htmlBefore) {
			$(this).html(htmlAfter);
		} else {
			$(this).html(htmlBefore);
		}
	});

	

	/*----- single product small image slider  ----------*/
      var $owlGallerySlider = $('.shop-product__small-image-gallery-slider'); 
      if($owlGallerySlider.length > 0){  
        $owlGallerySlider.owlCarousel({
          loop: false,
          nav: true,
          
          autoplay: false,
          autoplayTimeout: 8000,
          items: 5,
          margin: 5,
          dots:false,
          navText: ['<i class="ti-angle-left"></i>','<i class="ti-angle-right"></i>'],
          responsiveClass:true,
          responsive:{
            0:{
              items:3,
            },
            479:{
              items:3,
            },
            575:{
              items:3,
            },
            767:{
              items:4,
            },
            992:{
              items:4,
            },
            1200:{
              items:4,
            },

            1499: {
              items:5,
            }


          }
        });  
      };

	/*----------  single product small image slider vertical  ----------*/
      
      var $lezadaProudctVertical = $('.shop-product__small-image-gallery-slider--vertical');
      if($lezadaProudctVertical.length > 0){
        $lezadaProudctVertical.each(function () {
          var $this = $(this);
          $this.slick({
            infinite: true,
            arrows: true,
            dots: false,   
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: true,
            centerMode: true,
            prevArrow: '<button class="slick-prev"><i class="ti-angle-left"></i></button>',
            nextArrow: '<button class="slick-next"><i class="ti-angle-right"></i></button>',
            responsive: [{
              breakpoint: 1499,
              settings: {
                slidesToShow: 3,
              }
            },
                         {
                           breakpoint: 1199,
                           settings: {
                             slidesToShow: 3,
                           }
                         },
                         {
                           breakpoint: 991,
                           settings: {
                             slidesToShow: 3,
                           }
                         },
                         {
                           breakpoint: 767,
                           settings: {
                             slidesToShow: 3,
                             vertical: false,
                             arrows: false,
                             
                             centerMode: true,
                             centerPadding: "15px"

                           }
                         },
                         {
                           breakpoint: 575,
                           settings: {
                             slidesToShow: 3,
                             vertical: false,
                             arrows: false,
                             
                             centerMode: true,
                             centerPadding: "15px"
                           }
                         },
                         {
                           breakpoint: 479,
                           settings: {
                             slidesToShow: 2,
                             vertical: false,
                             arrows: false,
                             
                             centerMode: true,
                             centerPadding: "15px"
                           }
                         }
                        ]
          });
        });
      }

      /*----------   Payment method select  ----------*/

      $('[name="payment-method"]').on('click', function () {

        var $value = $(this).attr('value');

        $('.single-method p').slideUp();
        $('[data-method="' + $value + '"]').slideDown();

      });
      /*----------   Shipping form toggle  ----------*/

      $('[data-shipping]').on('click', function () {
        if ($('[data-shipping]:checked').length > 0) {
          $('#shipping-form').slideDown();
        } else {
          $('#shipping-form').slideUp();
        }
      });
	
      
      //grid-color-swatch
      $('.color-container li label, .color-container li .variant_img,.size-container li > span').on('click', function(){
        var variantImage = jQuery(this).parent().find('.variant_img a').attr('href');
        jQuery(this).parents('.single-product').find('.single-product__image > a.image-wrap img').attr({ src: variantImage, srcset: variantImage }); 
        return false;
      });
		
      // Single Product Dynamic Checkout Button
      $('#buy-now-check').on('click', function(){
        $(this).parent('.dynmiac_checkout--button').toggleClass('disabled');
      });
      // Popup Check Terms & Condition
      $('#popup_ageree_term_cond').on('click', function(){
        $(this).parent('.modal-button').toggleClass('disabled');
      });
      // Cart Page
      $('#cart_agree_to_check').on('click', function(){
        $(this).parent('.cart-calculation-button').toggleClass('disabled');
      });
      
      
  });	  
})(jQuery);